// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e9fd111b","455":"c8db2888"}[chunkId] + ".chunk.js";
};